const FUNDO_SITUACAO = {
  EM_FUNCIONAMENTO_NORMAL: {
    id: 'EM_FUNCIONAMENTO_NORMAL',
    value: 'Em Funcionamento Normal',
    descricao: 'Em Funcionamento',
    color: 'primary'
  },
  FASE_PRE_OPERACIONAL: {
    id: 'FASE_PRE_OPERACIONAL',
    value: 'Fase Pré-Operacional',
    descricao: 'Fase Pré-Operacional',
    color: 'info'
  },
  EM_LIQUIDACAO: {
    id: 'EM_LIQUIDACAO',
    value: 'Em Liquidação',
    descricao: 'Em Liquidação',
    color: 'warning'
  },
  CANCELADO: {
    id: 'CANCELADO',
    value: 'Cancelado',
    descricao: 'Cancelado',
    color: 'error'
  }
};

export default FUNDO_SITUACAO;
